import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import SubscriptionCompetitionsPage from "@/app/(custom-header)/subscriber-competitions/page";

const root = createRoot(document.getElementById("subscription-competitions-lobby") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <SubscriptionCompetitionsPage />
    </StoreProvider>
  </React.StrictMode>
);
